import type { QuizBuilderQuestionSchema } from '@repo/schemas/quiz/quizBuilderQuestion';

import { getPointsLabel } from '@repo/lib/quiz/getPointsLabel';
import { QuestionType } from '@repo/types/enums/questionType';
import { ChevronLeftIcon, CirclePlusIcon } from 'lucide-react';
import { useMemo, useState } from 'react';
import { Link, Navigate } from 'react-router';

import QuizBuilderQuestionType from '@/components/features/quiz/quiz-builder/QuizBuilderQuestionType';
import { Button } from '@/components/ui/button';
import { NumberSelect } from '@/components/ui/select';
import { useQuizBuilderQuestion } from '@/hooks/quiz';

export default function QuizBuilderContentQuestionPage() {
  const { data, onSubmit, sectionIndex, questionIndex } = useQuizBuilderQuestion();

  const supportsHeaderPoints = useMemo<boolean>(() => {
    const typesWithPoints: QuestionType[] = [QuestionType.SINGLE, QuestionType.TRANSLATE, QuestionType.LONG, QuestionType.VOICE];
    return typesWithPoints.includes(data.type);
  }, [data.type]);

  const [points, setPoints] = useState<number>(data.points);
  const formId = `question-${sectionIndex}-${questionIndex}`;

  const handleSubmit = (values: QuizBuilderQuestionSchema) => onSubmit(supportsHeaderPoints ? { ...values, points: points } : values);

  if (sectionIndex === -1 || questionIndex === -1) {
    return <Navigate to="../questions" replace />;
  }

  return (
    <>
      <div className="border-border-primary bg-card flex justify-between border-b p-4">
        <Button variant="outline" asChild>
          <Link to={'../questions'}>
            <ChevronLeftIcon />
            <span className="hidden sm:block">Anuluj</span>
          </Link>
        </Button>

        <div className="flex gap-3">
          {supportsHeaderPoints && (
            <NumberSelect value={String(points)} onValueChange={(value) => setPoints(Number(value))} start={1} end={20} getLabel={getPointsLabel} placeholder="Wybierz punkty" className="w-38" />
          )}

          <Button type="submit" form={formId} className="hidden md:flex">
            <CirclePlusIcon />
            Zapisz pytanie
          </Button>
        </div>
      </div>

      <div className="grow overflow-auto rounded-t-lg">
        <QuizBuilderQuestionType data={data} onSubmit={handleSubmit} id={formId} />
      </div>

      <div className="flex justify-end gap-3 border-t p-4 md:hidden">
        <Button type="submit" form={formId} className="w-full sm:w-fit">
          Zapisz
        </Button>
      </div>
    </>
  );
}
